/* Hushcase theme: colour-reactive hero, remembered iPhone model, quick add, colour strip, AJAX cart drawer. */
(function(){
"use strict";
var D=document,root=D.documentElement;
root.classList.remove("no-js");root.classList.add("js");
var HC=window.HC||{routes:{cart:"/cart",cartAdd:"/cart/add",cartChange:"/cart/change"},moneyFormat:"${{amount}}"};
function $(s,c){return (c||D).querySelector(s)}
function $$(s,c){return Array.prototype.slice.call((c||D).querySelectorAll(s))}
function esc(s){return String(s==null?"":s).replace(/[&<>"']/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]})}
var store={get:function(k){try{return localStorage.getItem(k)}catch(e){return null}},set:function(k,v){try{localStorage.setItem(k,v)}catch(e){}}};
var reduce=window.matchMedia&&matchMedia("(prefers-reduced-motion: reduce)").matches;

function money(cents){
  var v=(cents||0)/100,f=HC.moneyFormat||"${{amount}}";
  function grp(s,sep){return s.replace(/\B(?=(\d{3})+(?!\d))/g,sep)}
  var parts={
    amount:grp(v.toFixed(2),","),
    amount_no_decimals:grp(String(Math.round(v)),","),
    amount_with_comma_separator:grp(v.toFixed(2).replace(".",","),"."),
    amount_no_decimals_with_comma_separator:grp(String(Math.round(v)),"."),
    amount_with_apostrophe_separator:grp(v.toFixed(2),"'")
  };
  return f.replace(/\{\{\s*(\w+)\s*\}\}/g,function(m,k){return parts[k]||parts.amount}).replace(/<[^>]*>/g,"");
}

/* toast */
var toastT;
function toast(t){var e=$("#hc-toast");if(!e)return;e.textContent=t;e.classList.add("on");clearTimeout(toastT);toastT=setTimeout(function(){e.classList.remove("on")},2200)}

/* colour swatch metadata; unknown colours fall back to a neutral grey */
var META={
  "deep black":["#141416","#c9c9cf","rgba(255,255,255,.07)"],"black":["#141416","#c9c9cf","rgba(255,255,255,.07)"],
  "space grey":["#4a4a50","#b5b5bd","rgba(150,150,160,.14)"],"space gray":["#4a4a50","#b5b5bd","rgba(150,150,160,.14)"],
  "nardo gray":["#8a8a90","#cfd0d6","rgba(190,190,200,.14)"],"nardo grey":["#8a8a90","#cfd0d6","rgba(190,190,200,.14)"],
  "ocean blue":["#5f86c4","#8fb0e6","rgba(95,134,196,.22)"],"navy blue":["#1f3a55","#8fb0e6","rgba(40,90,150,.2)"],
  "burgundy":["#6e2a3c","#d77a95","rgba(160,50,80,.22)"],"orange":["#c8693a","#f4a261","rgba(244,162,97,.2)"],
  "midnight green":["#2f4a3a","#8fd1a6","rgba(80,140,100,.18)"],"brown":["#5a3a2c","#d6a27e","rgba(140,90,60,.18)"]
};
function meta(n){var m=META[String(n).toLowerCase()];return m?{hex:m[0],tint:m[1],glow:m[2]}:{hex:"#77777d",tint:"#d0d0d6",glow:"rgba(200,200,210,.12)"}}

/* ---------- product data ---------- */
var pEl=$("script[data-hc-product]"),P=null;
try{P=pEl?JSON.parse(pEl.textContent):null}catch(e){P=null}

function full(src,w){
  if(!src)return "";if(typeof src==="object")src=src.src||src.url||"";
  if(src.indexOf("//")===0)src="https:"+src;
  return w?src+(src.indexOf("?")>-1?"&":"?")+"width="+w:src;
}
function norm(src){return full(src).split("?")[0].replace(/^https?:/,"")}

var ci=-1,mi=-1,COLOURS=[],MODELS=[];
if(P&&P.variants&&P.variants.length){
  var names=(P.options||[]).map(function(o){return typeof o==="string"?o:(o&&o.name)||""});
  names.forEach(function(n,i){if(/colou?r/i.test(n))ci=i;else if(/model|iphone|device|phone|size/i.test(n)&&mi<0)mi=i});
  if(ci<0)ci=names.length-1;
  if(mi<0&&names.length>1)mi=ci===0?1:0;
  P.variants.forEach(function(v){
    var c=v.options[ci];if(COLOURS.indexOf(c)<0)COLOURS.push(c);
    if(mi>-1){var m=v.options[mi];if(MODELS.indexOf(m)<0)MODELS.push(m)}
  });
}
var VARIANT_IMGS={};
if(P)P.variants.forEach(function(v){if(v.featured_image)VARIANT_IMGS[norm(v.featured_image.src)]=1});
function imgFor(c){
  if(!P)return "";
  for(var i=0;i<P.variants.length;i++){var v=P.variants[i];if(v.options[ci]===c&&v.featured_image)return full(v.featured_image.src)}
  return full(P.featured_image);
}
function findVariant(m,c){
  if(!P)return null;
  for(var i=0;i<P.variants.length;i++){var v=P.variants[i];if(v.options[ci]===c&&(mi<0||v.options[mi]===m))return v}
  return null;
}
function colourAvailable(c){return P.variants.some(function(v){return v.options[ci]===c&&v.available&&(mi<0||!state.myModel||v.options[mi]===state.myModel)})}
var short=function(m){return String(m).replace(/^iPhone\s+/i,"")};

/* ---------- state ---------- */
var state={myModel:null,color:0,filterColor:null,pending:null};
var saved=store.get("hc_model");if(MODELS.indexOf(saved)>-1)state.myModel=saved;
var heroEl=$("[data-hc-hero]");
if(heroEl){var st=COLOURS.indexOf(heroEl.getAttribute("data-start"));if(st>-1)state.color=st}
var urlVariant=(location.search.match(/[?&]variant=(\d+)/)||[])[1];
if(urlVariant&&P){P.variants.forEach(function(v){if(String(v.id)===urlVariant){state.color=COLOURS.indexOf(v.options[ci]);if(mi>-1)state.myModel=v.options[mi]}})}
function model(){return state.myModel||MODELS[0]}

/* ---------- hero ---------- */
var heroFront="a",heroShown=-1,cycle=null,cycleDone=reduce,heroVisible=true;
function showHero(i){
  if(i===heroShown||!COLOURS.length)return;heroShown=i;var c=COLOURS[i],m=meta(c);
  root.style.setProperty("--glow",m.glow);root.style.setProperty("--tint",m.tint);
  if(heroEl){
    var front=$("[data-hc-hero-"+heroFront+"]",heroEl),back=$("[data-hc-hero-"+(heroFront==="a"?"b":"a")+"]",heroEl),src=imgFor(c);
    if(front&&back&&src&&norm(front.currentSrc||front.src)!==norm(src)){
      back.src=full(src,1000);back.alt=(P?P.title+" in ":"")+c;back.style.opacity=1;front.style.opacity=0;front.alt="";heroFront=heroFront==="a"?"b":"a";
    }
    $$("[data-hc-hero-swatches] .dot",heroEl).forEach(function(d,j){d.setAttribute("aria-pressed",j===i)});
    var l=$("[data-hc-hero-label]",heroEl);if(l)l.textContent=c;
  }
}
function setColor(i){state.color=i;showHero(i);renderCfg();renderStrip()}
function stopCycle(){cycleDone=true;clearInterval(cycle);cycle=null}
function startCycle(){if(cycleDone||cycle||!heroEl||COLOURS.length<2)return;cycle=setInterval(function(){if(D.hidden||!heroVisible)return;showHero((heroShown+1)%COLOURS.length)},4500)}
function buildHero(){
  if(!heroEl||!COLOURS.length)return;
  var h=$("[data-hc-hero-swatches]",heroEl);if(!h)return;h.innerHTML="";
  COLOURS.forEach(function(c,i){
    var b=D.createElement("button");b.type="button";b.className="dot";b.style.background=meta(c).hex;b.setAttribute("aria-label","Choose "+c);
    b.onclick=function(){stopCycle();setColor(i)};b.onmouseenter=function(){stopCycle();showHero(i)};h.appendChild(b);
  });
  var l=D.createElement("small");l.setAttribute("data-hc-hero-label","");h.appendChild(l);
  h.onmouseleave=function(){showHero(state.color)};
  // preload the other colours once the page is idle, so the hero crossfade never flashes blank
  var preload=function(){COLOURS.forEach(function(c){var im=new Image();im.src=full(imgFor(c),1000)})};
  if("requestIdleCallback" in window)requestIdleCallback(preload,{timeout:3000});else setTimeout(preload,1500);
  if("IntersectionObserver" in window){new IntersectionObserver(function(es){heroVisible=es[0].isIntersecting}).observe($(".heroimg",heroEl)||heroEl)}
}
["click","keydown"].forEach(function(t){D.addEventListener(t,function(e){if(!cycleDone&&!(e.target.closest&&e.target.closest("#hc-sheet")))stopCycle()})});

/* ---------- model picker ---------- */
var sheet=$("#hc-sheet");
function setModel(m){
  state.myModel=m;store.set("hc_model",m);
  var ms=$("#hc-model-short");if(ms)ms.textContent=short(m);
  renderHeroModels();renderChips();renderGrid();renderCfg();
}
/* "Your iPhone" buttons under the hero: picking a phone is inline, never a pop-up on arrival */
function renderHeroModels(){
  var w=$("[data-hc-hero-models]");if(!w||!MODELS.length)return;
  var c=$(".chips",w);if(!c)return;c.innerHTML="";
  MODELS.forEach(function(m){
    var b=D.createElement("button");b.type="button";b.className="chip";b.textContent=m;b.setAttribute("aria-pressed",state.myModel===m);
    b.onclick=function(){setModel(m)};c.appendChild(b);
  });
}
function openSheet(){
  if(!sheet||!MODELS.length)return;
  var g=$("#hc-mgrid");g.innerHTML="";
  MODELS.forEach(function(m){
    var b=D.createElement("button");b.type="button";b.textContent=short(m);b.setAttribute("aria-pressed",state.myModel===m);
    b.onclick=function(){setModel(m);closeSheet();if(state.pending!==null){var p=state.pending;state.pending=null;quickAdd(p)}else toast("Showing cases for your "+m)};
    g.appendChild(b);
  });
  sheet.classList.add("on");setTimeout(function(){var f=g.querySelector("button");if(f)f.focus()},50);
}
function closeSheet(){if(sheet)sheet.classList.remove("on");try{sessionStorage.setItem("hc_sheet","1")}catch(e){}}
if(sheet){
  $("#hc-skip").onclick=function(){state.pending=null;closeSheet()};
  sheet.addEventListener("click",function(e){if(e.target===sheet){state.pending=null;closeSheet()}});
}
var mb=$("#hc-model-btn");
if(mb){if(MODELS.length){mb.onclick=openSheet;if(state.myModel)$("#hc-model-short").textContent=short(state.myModel)}else mb.hidden=true}

/* ---------- shop grid ---------- */
var gridEl=$("[data-hc-grid]");
function renderChips(){
  var m=$("[data-hc-model-chips]");
  if(m){m.innerHTML="";MODELS.forEach(function(x){var b=D.createElement("button");b.type="button";b.className="chip";b.textContent=x;b.setAttribute("aria-pressed",state.myModel===x);b.onclick=function(){setModel(x)};m.appendChild(b)})}
  var s=$("[data-hc-filter-dots]");
  if(s){s.innerHTML="";COLOURS.forEach(function(c,i){var b=D.createElement("button");b.type="button";b.className="dot";b.style.background=meta(c).hex;b.title=c;b.setAttribute("aria-label","Show "+c);b.setAttribute("aria-pressed",state.filterColor===i);
    b.onclick=function(){state.filterColor=state.filterColor===i?null:i;renderChips();renderGrid()};s.appendChild(b)})}
}
function goToColour(i){
  stopCycle();
  var cfg=$("[data-hc-cfg]");
  if(cfg){setColor(i);cfg.scrollIntoView({behavior:reduce?"auto":"smooth"})}
  else if(P){var v=findVariant(model(),COLOURS[i]);location.href=P.url+(v?"?variant="+v.id:"")}
}
function renderGrid(){
  if(!gridEl||!P)return;
  var list=COLOURS.map(function(c,i){return i}).filter(function(i){return state.filterColor===null||i===state.filterColor});
  var lbl=$("[data-hc-count-label]");
  if(lbl)lbl.textContent=state.myModel?list.length+" fit your "+short(state.myModel):list.length+" colour"+(list.length===1?"":"s");
  gridEl.innerHTML="";
  var fitText=state.myModel?state.myModel:(gridEl.getAttribute("data-fit-all")||"");
  list.forEach(function(i){
    var c=COLOURS[i],v=findVariant(model(),c)||P.variants[0],avail=colourAvailable(c);
    var d=D.createElement("article");d.className="card rv";d.tabIndex=0;
    d.innerHTML='<div class="ph"><span class="badge">'+(avail?"NEW":"SOLD OUT")+'</span><img src="'+esc(full(imgFor(c),600))+'" srcset="'+esc(full(imgFor(c),400))+' 400w, '+esc(full(imgFor(c),600))+' 600w, '+esc(full(imgFor(c),900))+' 900w" sizes="(max-width:700px) 90vw, 290px" alt="'+esc(P.title+" in "+c)+'" loading="lazy" decoding="async" width="600" height="450">'+
      (avail?'<button type="button" class="qa" aria-label="Quick add '+esc(c)+'">+ Quick add</button>':"")+'</div>'+
      '<div class="ci"><h3>'+esc(P.title)+'</h3><small>'+esc(c)+'</small>'+(fitText?'<span class="fit">✓ Fits '+esc(fitText)+'</span>':'')+
      '<div class="price"><b>'+esc(money(v.price))+'</b>'+(v.compare_at_price>v.price?'<s>'+esc(money(v.compare_at_price))+'</s>':'')+'</div></div>';
    var q=$(".qa",d);if(q)q.onclick=function(e){e.stopPropagation();quickAdd(i)};
    d.onclick=function(){goToColour(i)};d.onkeydown=function(e){if(e.key==="Enter"&&e.target===d)goToColour(i)};
    gridEl.appendChild(d);observe(d);
  });
}

/* ---------- configurator ---------- */
var cfgEl=$("[data-hc-cfg]");
function currentVariant(){return findVariant(model(),COLOURS[state.color])}
function renderCfg(){
  if(!cfgEl||!P||!COLOURS.length)return;
  var c=COLOURS[state.color],v=currentVariant(),img=imgFor(c);
  var mainImg=$("[data-hc-main-img]",cfgEl);if(mainImg&&img){mainImg.src=full(img,1400);mainImg.alt=P.title+" in "+c}
  var ml=$("[data-hc-model-lbl]",cfgEl);if(ml)ml.textContent=state.myModel||"Choose your iPhone";
  var cl=$("[data-hc-colour-lbl]",cfgEl);if(cl)cl.textContent=c;
  var mt=$("[data-hc-model-tiles]",cfgEl);
  if(mt){mt.innerHTML="";MODELS.forEach(function(m){var b=D.createElement("button");b.type="button";b.className="tile";b.textContent=m;b.setAttribute("aria-pressed",state.myModel===m);b.onclick=function(){setModel(m)};mt.appendChild(b)})}
  var ct=$("[data-hc-colour-tiles]",cfgEl);
  if(ct){ct.innerHTML="";COLOURS.forEach(function(x,i){var b=D.createElement("button");b.type="button";b.className="tile ctile";b.innerHTML='<i style="background:'+meta(x).hex+'"></i>'+esc(x);b.setAttribute("aria-pressed",state.color===i);b.setAttribute("data-soldout",!colourAvailable(x));b.onclick=function(){stopCycle();setColor(i)};ct.appendChild(b)})}
  var th=$("[data-hc-thumbs]",cfgEl);
  if(th){
    th.innerHTML="";
    var extra=(P.images||[]).filter(function(s){return !VARIANT_IMGS[norm(s)]});
    [img].concat(extra).filter(Boolean).forEach(function(u,i){
      var b=D.createElement("button");b.type="button";b.setAttribute("aria-pressed",i===0);b.setAttribute("aria-label","Photo "+(i+1));
      b.innerHTML='<img src="'+esc(full(u,200))+'" alt="" loading="lazy">';
      b.onclick=function(){if(mainImg)mainImg.src=full(u,1400);$$("button",th).forEach(function(x){x.setAttribute("aria-pressed","false")});b.setAttribute("aria-pressed","true")};
      th.appendChild(b);
    });
  }
  var pr=$("[data-hc-price]",cfgEl),cp=$("[data-hc-compare]",cfgEl);
  if(v&&pr)pr.textContent=money(v.price);
  if(cp){cp.textContent=v&&v.compare_at_price>v.price?money(v.compare_at_price):""}
  var sel=$("select[name=id]",cfgEl);if(sel&&v)sel.value=v.id;
  var add=$("[data-hc-add]",cfgEl);
  if(add){add.disabled=!!(state.myModel&&!(v&&v.available));add.textContent=add.disabled?"Sold out":(add.getAttribute("data-label")||"Add to cart")}
  var sb=$("[data-hc-sb-sub]");if(sb)sb.textContent=(state.myModel?short(state.myModel):"Pick your iPhone")+" · "+c+(v?" · "+money(v.price):"");
  var sn=$("[data-hc-sb-name]");if(sn)sn.textContent=P.title;
  if(cfgEl.hasAttribute("data-product-page")&&v&&history.replaceState&&state.myModel){history.replaceState(null,"",location.pathname+"?variant="+v.id)}
}

/* ---------- colour comparison strip ---------- */
var stripEl=$("[data-hc-strip]");
function renderStrip(){
  if(!stripEl||!P)return;stripEl.innerHTML="";
  COLOURS.forEach(function(c,i){
    var d=D.createElement("div");d.className="sc";d.setAttribute("aria-current",state.color===i);
    d.innerHTML='<div class="im"><img src="'+esc(full(imgFor(c),500))+'" srcset="'+esc(full(imgFor(c),360))+' 360w, '+esc(full(imgFor(c),500))+' 500w, '+esc(full(imgFor(c),800))+' 800w" sizes="(max-width:900px) 46vw, 360px" alt="'+esc(P.title+" in "+c)+'" loading="lazy" decoding="async" width="500" height="375"></div><div class="b"><span><i style="background:'+meta(c).hex+'"></i>'+esc(c)+'</span><button type="button">Choose</button></div>';
    $("button",d).onclick=function(){goToColour(i)};stripEl.appendChild(d);
  });
}

/* ---------- cart (Shopify AJAX API) ---------- */
var drawer=$("#hc-drawer"),ov=$("#hc-ov");
function openCart(){if(drawer){drawer.classList.add("on");ov.classList.add("on")}else location.href=HC.routes.cart}
function closeCart(){if(drawer){drawer.classList.remove("on");ov.classList.remove("on")}}
function bump(){var cb=$("#hc-open-cart");if(!cb)return;cb.classList.remove("bump");void cb.offsetWidth;cb.classList.add("bump")}
function renderCart(c){
  var cnt=$("#hc-count");if(cnt)cnt.textContent=c.item_count;
  var it=$("#hc-items");if(!it)return;it.innerHTML="";
  if(!c.item_count){it.innerHTML='<p class="empty">Your bag is empty.</p>'}
  c.items.forEach(function(x){
    var d=D.createElement("div");d.className="it";
    d.innerHTML=(x.image?'<img src="'+esc(full(x.image,200))+'" alt="">':'<span></span>')+
      '<div><b>'+esc(x.product_title)+'</b><small>'+esc(x.variant_title||"")+'</small><div class="qty"><button type="button" aria-label="Decrease quantity">−</button>'+x.quantity+'<button type="button" aria-label="Increase quantity">+</button></div></div><b>'+esc(money(x.final_line_price))+'</b>';
    var bs=$$(".qty button",d);
    bs[0].onclick=function(){changeLine(x.key,x.quantity-1)};bs[1].onclick=function(){changeLine(x.key,x.quantity+1)};
    it.appendChild(d);
  });
  var sub=$("#hc-subtotal");if(sub)sub.textContent=money(c.total_price);
  var co=$("#hc-checkout");if(co)co.disabled=!c.item_count;
}
function getCart(){return fetch(HC.routes.cart+".js",{headers:{Accept:"application/json"}}).then(function(r){return r.json()}).then(function(c){renderCart(c);return c})}
function changeLine(key,q){
  return fetch(HC.routes.cartChange+".js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({id:key,quantity:Math.max(0,q)})})
    .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})}).then(renderCart).catch(function(e){toast((e&&e.description)||"Could not update your bag")});
}
function addVariant(v){
  if(!v){toast("Please choose an option");return Promise.resolve(false)}
  if(!v.available){toast("Sorry, that one is sold out");return Promise.resolve(false)}
  return fetch(HC.routes.cartAdd+".js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({items:[{id:v.id,quantity:1}]})})
    .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
    .then(function(){return getCart()}).then(function(){bump();return true})
    .catch(function(e){toast((e&&e.description)||"Could not add to your bag");return false});
}
function quickAdd(i){
  if(MODELS.length&&!state.myModel){state.pending=i;openSheet();return}
  var c=COLOURS[i];addVariant(findVariant(model(),c)).then(function(ok){if(ok)toast("Added "+c+(state.myModel?" · "+short(state.myModel):""))});
}
function addCurrent(e){
  if(e)e.preventDefault();
  if(MODELS.length&&!state.myModel){state.pending=state.color;openSheet();return}
  addVariant(currentVariant()).then(function(ok){if(ok)openCart()});
}
var oc=$("#hc-open-cart");if(oc&&drawer)oc.addEventListener("click",function(e){e.preventDefault();openCart()});
var cc=$("#hc-close-cart");if(cc)cc.onclick=closeCart;if(ov)ov.onclick=closeCart;
if(cfgEl){var form=$("form",cfgEl);if(form)form.addEventListener("submit",addCurrent)}
var sba=$("[data-hc-sb-add]");if(sba)sba.onclick=addCurrent;
D.addEventListener("keydown",function(e){if(e.key==="Escape"){closeCart();if(sheet&&sheet.classList.contains("on")){state.pending=null;closeSheet()}}});

/* ---------- scroll effects ---------- */
var io="IntersectionObserver" in window?new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add("in");io.unobserve(e.target)}})},{threshold:.12}):null;
function observe(el){if(io)io.observe(el);else el.classList.add("in")}
$$(".rv").forEach(observe);
var pars=$$("[data-par]"),sbar=$("[data-hc-sbar]");
function onScroll(){
  if(!reduce)pars.forEach(function(el){var r=el.parentElement.getBoundingClientRect();el.style.transform="translateY("+((r.top-innerHeight/2)*-parseFloat(el.getAttribute("data-par")))+"px)"});
  if(sbar&&cfgEl){var r=cfgEl.getBoundingClientRect();sbar.classList.toggle("on",r.top<innerHeight*.4&&r.bottom>innerHeight*.5)}
}
addEventListener("scroll",onScroll,{passive:true});

/* ---------- start ---------- */
buildHero();renderHeroModels();renderChips();renderGrid();
if(COLOURS.length)setColor(Math.max(0,state.color));
onScroll();startCycle();
if(drawer)getCart().catch(function(){});
})();
